import React from 'react'

const SvgFaqFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M4 7h-.5A1.5 1.5 0 002 8.5V22l4-3h9.594c.828 0 1.406-.578 1.406-1.406V17H6a2 2 0 01-2-2V7z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.6 2A1.6 1.6 0 006 3.6v9.9c0 .884.616 1.5 1.5 1.5h9.7l4.8 3V3.6A1.6 1.6 0 0020.4 2H7.6zm5.48 6.14v1.53h1.4v-.72c.233-.04.457-.113.67-.22.213-.107.4-.243.56-.41.16-.173.287-.373.38-.6.093-.227.14-.48.14-.76 0-.307-.057-.587-.17-.84a1.753 1.753 0 00-.47-.65 2.232 2.232 0 00-.74-.42c-.287-.1-.603-.15-.95-.15-.34 0-.64.047-.9.14a2.262 2.262 0 00-.66.37c-.18.147-.327.317-.44.51a2.5 2.5 0 00-.26.58l1.22.51c.06-.247.173-.45.34-.61.173-.16.39-.24.65-.24.24 0 .433.067.58.2.153.133.23.327.23.58v.14c0 .373-.133.64-.4.8-.26.153-.653.24-1.18.26zm.03 3.76c.14.147.37.22.69.22.32 0 .547-.073.68-.22a.753.753 0 00.21-.54v-.24a.753.753 0 00-.21-.54c-.133-.147-.36-.22-.68-.22-.32 0-.55.073-.69.22a.774.774 0 00-.2.54v.24c0 .213.067.393.2.54z'
    />
  </svg>
)

export default SvgFaqFilled
